<template>
  <div id="timeline" class="row">
    <div class="w-100 d-flex pl-1">
      <div class="col-6" v-for="componente in componentesDeCamaras" v-if="componente.componenteDeCamaraId != undefined && componente.componenteDeCamaraId != null && componente.componenteDeCamaraId == enumeraciones.componentesDeCamaras.LineaDeTiempo" id="LineaDeTiempo_btn">
        <div v-on:click="avance" class="barra-tiempo">
          <div :style="{ width: porcentajeReproducido + '%' }" class="avance-barra"></div>
        </div>
        <div id="timer">
          <span class="ti">{{tiempoActual | convertirHoraHHMMSS}}</span>
          <span class="tf">{{duracion | convertirHoraHHMMSS}}</span>
        </div>
      </div>
      <div class="col-6 d-flex justify-content-between align-items-center pl-3">
        <div v-if="video == undefined">
          <button @click="comenzarVideo()" class="btn btn-success" v-for="componente in componentesDeCamaras" v-if="componente.componenteDeCamaraId != undefined && componente.componenteDeCamaraId != null && componente.componenteDeCamaraId == enumeraciones.componentesDeCamaras.Comenzar" id="Comenzar_btn">
            <i class="fas fa-play"></i> Comenzar
          </button>
        </div>
        <div v-if="play">
          <button @click="playvideo()" class="btn btn-success" v-for="componente in componentesDeCamaras" v-if="video != undefined && componente.componenteDeCamaraId != undefined && componente.componenteDeCamaraId != null && componente.componenteDeCamaraId == enumeraciones.componentesDeCamaras.Reproducir" id="Reproducir_btn">
            <i class="fas fa-play"></i> Reproducir
          </button>
        </div>
        <div v-else>
          <button @click="pausevideo()" class="btn btn-danger" v-for="componente in componentesDeCamaras" v-if="componente.componenteDeCamaraId != undefined && componente.componenteDeCamaraId != null && componente.componenteDeCamaraId == enumeraciones.componentesDeCamaras.Reproducir" id="Reproducir_btn">
            <i class="fas fa-pause"></i> Pausar
          </button>
        </div>
        <button class="btn btn-danger" v-for="componente in componentesDeCamaras" v-if="componente.componenteDeCamaraId != undefined && componente.componenteDeCamaraId != null && componente.componenteDeCamaraId == enumeraciones.componentesDeCamaras.Finalizar" id="Finalizar_btn">
          <i class="fas fa-stop"></i> Finalizar
        </button>
        <button class="btn btn-secondary" v-for="componente in componentesDeCamaras" v-if="componente.componenteDeCamaraId != undefined && componente.componenteDeCamaraId != null && componente.componenteDeCamaraId == enumeraciones.componentesDeCamaras.CambiarSala" id="CambiarSala_btn">
          <i class="fas fa-exchange-alt"></i> Cambiar Sala
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'

  export default {
    data() {
      return {
        enumeraciones,
        video: undefined,
        duracion: 0,
        tiempoActual: 0,
        play: true,
        rutas: [],
        sesionesIndex: 1
      }
    },
    props: {
      componentesDeCamaras: {},
      parametros: Object
    },
    filters: {
      convertirHoraHHMMSS(val) {
        let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);

        return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
      }
    },
    computed: {
      porcentajeReproducido() {
        return parseInt(this.tiempoActual / this.duracion * 100);
      }
    },
    methods: {
      cambiarVideo(e) { //debugger
        this.play = true;
        this.video = null;
        //console.log(this.parametros.SesionDeLaAudienciaId);
        if (this.parametros.SesionesDeLasAudiencias != undefined && this.parametros.SesionesDeLasAudiencias.length > this.sesionesIndex) {          
          //this.rutas = this.parametros.SesionesDeLasAudiencias[this.sesionesIndex].RutasDeVideos;
                    
          this.video= document.getElementById('video_sesion' + this.parametros.SesionDeLaAudienciaId);
          //videoNuevo.src = this.parametros.SesionesDeLasAudiencias[this.sesionesIndex].RutasDeVideos[0].Ruta;            
          this.video.load();
          //videoNuevo.play();                      
          //this.sesionesIndex++;
        }     
      },
      comenzarVideo() {
          this.video = document.getElementById('video_sesion' + this.parametros.SesionDeLaAudienciaId);
          document.getElementById('video_sesion' + this.parametros.SesionDeLaAudienciaId).addEventListener('ended', this.cambiarVideo, false);      

        if (isNaN(this.video.duration)) {
          comun.mensajeDeAlerta("No hay vídeo para reproducir.", null, null);
        } else {
          this.duracion = parseFloat(this.video.duration.toFixed(2).toString());
          this.video.addEventListener('timeupdate', this.actualizar);
          this.playvideo();
          this.$emit("EstadoReproductor",{'Estatus': true});
        }
      },
      avance(e) {
        if (e.target.tagName === 'SPAN')
          return;
        this.rutas.forEach((element) => {
          const videoCamara = document.getElementById("camara" + element.Camara.CamaraId);
          if (!videoCamara)
            return

          const el = e.target.getBoundingClientRect();
          const posicionBarra = (e.clientX - el.left) / el.width;

          videoCamara.currentTime = parseInt(videoCamara.duration * posicionBarra);
        });
      },
      actualizar(e) {
        this.tiempoActual = parseInt(this.video.currentTime);
        const parametros = {
          llave: "reproductor_tiempoActualVideo",
          valor: this.tiempoActual
        }
        this.$store.dispatch("A_Forseti_Catalogo_EstablecerTiempoActualVideo", parametros);
        if(this.video.currentTime ==this.video.duration || this.video.currentTime ==this.video.duration){
           this.$emit("EstadoReproductor",{'Estatus': false});
       }
      },
      playvideo() {        
        this.video.play();
        this.$emit("EstadoReproductor",{'Estatus': true});
        this.play = false;
      },
      pausevideo() {        
        this.video.pause();
        this.play = true;
        this.$emit("EstadoReproductor",{'Estatus': false});
      },
    },
    created() {
    },
    mounted() {
      if (this.parametros.Sala != null && this.parametros.Sala != undefined)
        this.componentesDeCamaras;
    }
  }
</script>
<style>
  #timer {
    display: flex;
    justify-content: space-between;
  }

  .barra-tiempo {
    background-color: black;
    cursor: pointer;
    height: 50%;
    min-width: 200px;
    position: relative;
  }

  .avance-barra {
    background-color: grey;
    bottom: 0;
    left: 0;
    position: absolute;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Comun/PanelDeAccionesCamaras.vue